module.exports = __webpack_public_path__ + "img/calendar-week.608abf04.svg";